import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button } from './Button';
import { NewBadge } from './StatusChip';

export interface ArticleCardProps {
  title: string;
  preview: string;
  /** already formatted for display — formatting policy lives with the page */
  date: string;
  isNew?: boolean;
  onViewSummary: () => void;
}

export function ArticleCard({ title, preview, date, isNew = false, onViewSummary }: ArticleCardProps) {
  return (
    <Box
      sx={{
        // New articles get the blue highlight drawn in Figma 2871:51292:
        // 1px #01ADEF border plus the shared "Button Shadow #2" pair — the
        // same shadow the theme's MuiMenu/MuiPopover overrides carry.
        border: isNew ? '1px solid #01ADEF' : '1px solid #DEDEDE',
        boxShadow: isNew
          ? '0 -1px 2px rgba(0,0,0,0.02), 0 4px 9px rgba(0,0,0,0.05)'
          : 'none',
        // Radius 8px per the Figma card component (was 12px, a kit-era guess).
        borderRadius: '8px',
        p: 2.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        backgroundColor: '#FFFFFF',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}>
        <Typography variant="h5" sx={{ wordBreak: 'break-word' }}>
          {title}
        </Typography>
        {isNew && <NewBadge />}
      </Box>
      <Typography
        fontSize={14}
        color="text.secondary"
        sx={{
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        {preview}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 'auto' }}>
        <Button variant="secondary" onClick={onViewSummary}>
          View summary
        </Button>
        <Typography fontSize={12} color="text.secondary">
          {date}
        </Typography>
      </Box>
    </Box>
  );
}
